import { drawCrosshatch } from '@/threejs/utils/canvasPatterns';
import type { InputSource } from './types';

export const crosshatch: InputSource = {
  label: 'Crosshatch',
  value: 'crosshatch',
  draw: (ctx, width, height) => {
    drawCrosshatch(ctx, width, height);
  },
};
